import { render, staticRenderFns } from "./BlogPostShare.vue?vue&type=template&id=5560fd68"
import script from "./BlogPostShare.vue?vue&type=script&lang=js"
export * from "./BlogPostShare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports